import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../shared/services/http.service';
import { HttpClient } from '@angular/common/http';
import { encodeToBase64 } from '../../utility';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OutcomesService {

  private templatesList = `${environment.opbBackendHost}/api/admin/outcome/templates`; 
  private yearsList = `${environment.opbBackendHost}/api/admin/outcome/templates/years`;
  private templatesDownload = `${environment.opbBackendHost}/api/admin/outcome/templates/download`;
  private designations = `${environment.opbBackendHost}/api/admin/user/designations`;
  private businessThemesUrl = `${environment.opbBackendHost}/api/admin/theme/list/year`;
  private groups= `${environment.opbBackendHost}/api/admin/group/list/all`;
  private users= `${environment.opbBackendHost}/api/admin/user/list`;
  private uploadFileUrl = `${environment.opbBackendHost}/api/admin/outcome/templates/upload`;
  private syncUrl = `${environment.opbBackendHost}/api/admin/outcome/templates/sync`;
    
  http=inject(HttpClient);
  httpService=inject(HttpService);

  getTemplates(data: any): Observable<any> {
      return this.httpService.post(this.templatesList,data);
  }

  getYears(data: any): Observable<any> {
    return this.httpService.post(this.yearsList,data);
  }

  getDesignations(data: any): Observable<any> {
    return this.httpService.post(this.designations,data);
  }

  getBusinessThemes(data: any): Observable<any> {
    return this.httpService.post(this.businessThemesUrl, data);
  }

  getGroups(data: any): Observable<any> {
    return this.httpService.post(this.groups,data);
  }

  getUsers(data: any): Observable<any> {
    return this.httpService.post(this.users,data);
  }

  // downloadTemplate(data: any): Observable<any> {
  //   //return this.http.post<any>(this.templatesDownload,{ responseType: 'blob' });

  //   return this.httpService.postPure(this.templatesDownload,data);
  // }

  downloadTemplate(payload: any): Observable<Blob> {
    const data = { payload: encodeToBase64(JSON.stringify(payload)) };
      return this.http.post(this.templatesDownload, data, {
        responseType: 'blob',
        withCredentials: true
      });
    }
 
  uploadFile(file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.httpService.postWithDecode(this.uploadFileUrl,formData);
  }

  syncTempToOutcomes(data: any): Observable<any> {
    return this.httpService.post(this.syncUrl,data);
  }
}
